<template>
    <div>
        <b-modal
            :id="modalId"
            modal-class="modal-confirm-surprise"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base"
                :class="{'farmer': theme == 'farmer', 'subdist': theme == 'subdist', 'dist': theme == 'dist', 'sale': theme == 'sale'}">
                <div class="modal-base-head">
                    <div class="surprise-point-bg font-semi-bold" v-if="campaignPoint > 0">
                        <div class="text-free">{{lblSurprise.free}}</div>
                        <div class="text-point">{{`${campaignPoint} ${lblSurprise.point_unit}`}}</div>
                    </div>
                    <div class="surprise-campaign-image" v-if="campaign">
                        <img :src="campaign.fullImageUrl" class="img-fluid" />
                    </div>
                    <!-- <p id="confirm_surprise_modal_title" class="modal-head-txt theme-txt" v-html="lblSurprise.headline"></p> -->
                </div>
                <div class="modal-base-body">
                    <p id="confirm_surprise_modal_msg" class="modal-body-txt"
                        v-html="msg">
                    </p>
                </div>
                <div class="modal-base-footer" v-if="isFreeDelivery">
                    <div id="confirm_surprise_modal_btn_sigle">
                        <div class="conform-modal-btn">
                            <div class="btn-wrapper">
                                <div class="btn-txt"
                                    @click="clickConfirm">
                                    {{btnOk}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer" v-else>
                    <div id="confirm_surprise_modal_btn_row">
                        <div class="conform-modal-btn">
                            <div class="btn-wrapper btn-cancel">
                                <div class="btn-txt"
                                    @click="clickCancel">
                                    {{btnCancel}}
                                </div>
                            </div>
                        </div>
                        <div class="conform-modal-btn">
                            <div class="btn-wrapper">
                                <div class="btn-txt"
                                    @click="clickConfirm">
                                    {{btnOk}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Moment from "moment";
//helper
import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/locale.js";

export default {
    name: 'ConfirmSurpriseModal',
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            lblSurprise: {},
            lblDate: {},
            localeCode: Locale.getLocaleCode(),

            campaignPoint: 0,
            campaign: {},
            pointTypeMsg: '',
            msg: '',
            tag: '',
            btnOk: '',
            btnCancel: '',

            busModal: null,
            isFreeDelivery: false
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.lblSurprise = this.lbl.surprise;
        this.lblDate = this.lbl.date;

        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //Event
        clickConfirm: function () {
            this.hide();
            this.controller.sendCallbackConfirm({tag: this.tag});
        },
        clickCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel({tag: this.tag});
        },
        //modal
        show: function (config) {
            if(config.campaign){
                this.campaign = config.campaign;
                this.msg = this.campaign.name;
            }

            if(config.point){
                this.campaignPoint = config.point;
                this.msg = Util.stringFormat(this.lblSurprise.pre_point_msg, this.campaignPoint);
            }

            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;
            //this.initialModal();
            this.checkFreeDelivery(this.campaign.name);
            this.checkFreeNonDelivery(this.campaign.name)
            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        },
        //Method
        initialModal: function () {
            var minute = this.campaign.minutesValidAfterUsed;
            var isDelivered = false;
            var haveTimer = false;

            if(this.campaign.delivered) isDelivered = true;
            if(this.campaign.minutesValidAfterUsed
                || this.campaign.minutesValidAfterUsed > 0) haveTimer = true;

            this.headline = this.lblConfirmRedeem.headline;
            switch(this.campaign.type) {
                case Vue.CampaignType.Draw:
                    this.message = isDelivered
                        ? this.lblConfirmRedeem.draw_delivery
                        : this.getDrawMessage(this.lblConfirmRedeem.draw);
                    break;
                case Vue.CampaignType.Free:
                    if(isDelivered) {
                        this.message = this.lblConfirmRedeem.free_delivery;
                        this.isFreeDelivery = true;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(this.lblConfirmRedeem.free, minute)
                            : this.lblConfirmRedeem.free_no_timer;
                    }
                    break;
                case Vue.CampaignType.Deal:
                    if(isDelivered) {
                        this.message = this.lblConfirmRedeem.deal_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(this.lblConfirmRedeem.free, minute)
                            : this.lblConfirmRedeem.deal_no_timer;
                    }
                    break;
                case Vue.CampaignType.Buy:
                    this.message = this.lblConfirmRedeem.buy;
                    break;
                case Vue.CampaignType.Interface:
                    this.message = this.lblConfirmRedeem.interface;
                    break;
                default:
                    break;
            }
        },
        checkFreeDelivery: function(name) {
            if (this.tag == 'surprise-campaign-delivery') {
                this.isFreeDelivery = true;
                this.msg = Util.stringFormat(this.lblSurprise.msg_free_delivery + name);
            }
        },
        checkFreeNonDelivery: function(name) {
            if (this.tag == 'surprise-campaign') {
                this.msg = Util.stringFormat(this.lblSurprise.msg_free_delivery + name);
            }
        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
}
</script>
<style lang="scss">
    @import "@/style/base/common.scss";
    @import "@/style/modal.scss";
    .modal-confirm-surprise {
        @extend %modal-base;

        .modal-dialog .modal-content .modal-body {
            padding: 20px 20px 10px;
        }

        .surprise-point-bg{
            background-image: url('../../../../assets/image/Surprise/bg-image-point.png');
            background-position: top center;
            background-repeat: no-repeat;
            background-size: 186px;
            font-size: 1.6rem;
            text-align: center;
            position: absolute;
            bottom: -30px;
            left: 0;
            right: 0;
            width: 100%;
            height: 130px;

            .text-free{
                font-family: $semi_bold;
                color: $green-00987F;
                line-height: 0;
                padding: {
                    top: 65px;
                };
            }
            .text-point{
                font-family: $bold;
                color: $orange1;
            }
        }

        .surprise-campaign-image{
            position: absolute;
            bottom: -30px;
            left: 0;
            right: 0;
            width: 218px;
            margin: auto;

            img{
                border-radius: 5px;
            }

        }
    }

    .confirm-modal-txt {
        margin-bottom: 0;
        text-align: center;
    }

    #confirm_surprise_modal_title {
        padding: 10px 10px 0;
        //font
        font-family: $semi_bold;
        line-height: 1;
    }

    #confirm_surprise_modal_msg {
        padding: 45px 10px 25px;
        //font
        font-family: $regular;
        word-break: break-work;
        line-height: 1;
    }
    #confirm_surprise_modal_btn_sigle {
        width: 100%;
        padding-bottom: 7px;

        .conform-modal-btn {
            &:nth-child(1) {
                padding-right: 7px;
            }

            &:nth-child(2) {
                padding-left: 7px;
            }
        }
     }

    #confirm_surprise_modal_btn_row {
        @extend %display-flex;
        width: 100%;
        padding-bottom: 7px;

        .conform-modal-btn {
            width: 50%;
            flex: 0 0 50%;

            &:nth-child(1) {
                padding-right: 7px;
            }

            &:nth-child(2) {
                padding-left: 7px;
            }
        }
     }
</style>
